import { AxonEventNames } from '../../entities';
import { AxonService } from '../../interfaces';

export class AxonServiceDecorator implements AxonService {
  constructor(protected readonly axonService: AxonService) {}

  isAxonAvailable(): boolean {
    return this.axonService.isAxonAvailable();
  }

  isAxonRequired(): boolean {
    return this.axonService.isAxonRequired();
  }

  track(eventName: AxonEventNames, data?: Record<string, unknown>): void {
    this.axonService.track(eventName, data);
  }
}
